import moment from 'moment';
import LoginAsMixin from '@/mixins/LoginAsMixin';

export function toIdr(value, params = {}) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...params
  })
    .format(value)
    .replace(/^(\D+)/, '$1 ');
}

export function formatIDR(value, params = {}) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    ...params
  })
    .format(value)
    .replace(/^(\D+)/, '$1');
}

export function formatIDRWithoutSign(value, params = {}) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    ...params
  })
    .format(value)
    .replace(/^(\D+)/, '');
}

export function toCurrencyWithoutSign(value, params = {}) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...params
  })
    .format(value)
    .replace(/^(\D+)/, '');
}

export function amountToFixed(value) {
  return value.toFixed(2);
}

export function formatDate(date, format = 'DD-MM-YYYY') {
  if (!date) return date;

  return moment(date).format(format);
}

export function tableRowValue(header, item) {
  return header.formatter
    ? header.formatter(item[header.value])
    : item[header.value];
}

export function exportValue(header, item) {
  const headerValue = header.value;
  const formatter = header.exportFormat || header.formatter;

  return formatter ? formatter(item[headerValue]) : item[headerValue];
}

export function toEur(value) {
  if (value < 0) {
    return '(' + (Math.abs(value) / 1000000).toFixed(1) + ')';
  } else if (value > 0) {
    return (Math.abs(value) / 1000000).toFixed(1);
  } else {
    return value;
  }
}

export function toMIDR(num) {
  let val = Number(num);
  if (val < 0) {
    return '(' + (Math.abs(val) / 1000000000).toFixed(1) + ')';
  } else if (val > 0) {
    return (Math.abs(val) / 1000000000).toFixed(1);
  } else {
    return num;
  }
}

export function idr(val) {
  let value = Math.round(val);
  let number = Number(value);
  if (value) {
    if (isNaN(number)) {
      return value;
    } else {
      if (value == 0) {
        return '-';
      } else {
        return Number(value).toLocaleString('id-ID', {
          maximumFractionDigits: 2
        });
        // return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    }
  } else {
    return '-';
  }
}

export function BIDRFormat(value) {
  return (Math.abs(Number(value)) / 1.0e9).toFixed(1);
}

export function MIDRFormat(value) {
  return (Math.abs(Number(value)) / 1.0e6).toFixed(1);
}

export default {
  filters: {
    toIdr,
    toCurrencyWithoutSign,
    formatDate,
    tableRowValue,
    amountToFixed
  },
  mixins: [LoginAsMixin],
  methods: {
    idr(val) {
      let value = Math.round(val);
      let number = Number(value);
      if (value) {
        if (isNaN(number)) {
          return value;
        } else {
          if (value == 0) {
            return '-';
          } else {
            return Number(value).toLocaleString('id-ID', {
              maximumFractionDigits: 2
            });
            // return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          }
        }
      } else {
        return '-';
      }
    },
    idrFilter(value) {
      let number = Number(value);
      if (value) {
        if (isNaN(number)) {
          return value;
        } else {
          if (value == 0) {
            return '-';
          } else {
            let val = Math.round(value);
            return Number(val).toLocaleString('id-ID', {
              maximumFractionDigits: 2
            });
            // return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          }
        }
      } else {
        return '-';
      }
    },
    idrRp(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR'
      })
        .format(value)
        .replace(/^(\D+)/, '$1 ');
    },
    eur(value) {
      // if (value) {
      //   return new Intl.NumberFormat('de-DE', {
      //     style: 'currency',
      //     currency: 'EUR',
      //     minimumFractionDigits: 0,
      //     maximumFractionDigits: 0
      //   })
      //     .format(value)
      //     .replace(/^(\D+)/, '$1 ');
      // }
      if (value < 0) {
        return '(' + (Math.abs(value) / 1000000).toFixed(1) + ')';
      } else if (value > 0) {
        return (Math.abs(value) / 1000000).toFixed(1);
      } else {
        return value;
      }
    },
    currFormatter(num) {
      let val = Number(num);
      if (val < 0) {
        return '(' + (Math.abs(val) / 1000000000).toFixed(1) + ')';
      } else if (val > 0) {
        return (Math.abs(val) / 1000000000).toFixed(1);
      } else if (val === 0) {
        return '';
      }
    },
    currFormatter2(num) {
      let val = Number(num);
      if (val < 0) {
        return '(' + (Math.abs(val) / 1000000000).toFixed(2) + ')';
      } else if (val > 0) {
        return (Math.abs(val) / 1000000000).toFixed(2);
      } else if (val === 0) {
        return '';
      }
    },
    formatMonth(date) {
      return moment(date, 'M').format('MMM');
    },
    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },
    formatYear(date) {
      return moment(date).format('YYYY');
    },
    formatMonthYear: function(value) {
      return moment(value).format('MMMM YYYY');
    },
    formatDateTime: function(value) {
      return moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss');
    },
    formattedDate: function(value) {
      if (value == null) {
        return '-';
      } else {
        return moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY');
      }
    },
    formattedDate2: function(value) {
      if (value == null) {
        return '-';
      } else {
        return moment(value, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
      }
    },
    strLimit(val, max = 60, extra = '...') {
      if (val && val.length > max) {
        return val.slice(0, max) + extra;
      }
      return val;
    },
    nameMonth(val) {
      var name;
      const month = val.slice(5, 7);
      switch (month) {
        case '01':
          name = 'January';
          break;
        case '02':
          name = 'February';
          break;
        case '03':
          name = 'March';
          break;
        case '04':
          name = 'April';
          break;
        case '05':
          name = 'May';
          break;
        case '06':
          name = 'June';
          break;
        case '07':
          name = 'July';
          break;
        case '08':
          name = 'August';
          break;
        case '09':
          name = 'September';
          break;
        case '10':
          name = 'October';
          break;
        case '11':
          name = 'November';
          break;
        case '12':
          name = 'December';
          break;
      }
      return name;
    },
    usageBudget(val1, val2) {
      if (val2 == 0) {
        return '-';
      } else if (val2 > 0) {
        const usage = ((val1 / val2) * 100).toFixed(0);
        if (usage == 0) {
          return '-';
        } else {
          return usage + '%';
        }
      }
    },
    usageBudgetPersen(val1, val2) {
      if (val2 == 0 || val2 == undefined || val1 === undefined) {
        return '-';
      } else if (val2 > 0) {
        const usage = ((val1 / val2) * 100).toFixed(0);
        if (usage == 0) {
          return '-';
        } else {
          return usage;
        }
      }
    },
    startFrom(arr, idx) {
      return arr.slice(0, idx);
    },
    bgSticky(val) {
      if (!val) {
        return '';
      } else {
        return 'bgPink';
      }
    },
    checkColumnActive(item) {
      let month;
      if (item.month === 'total') {
        month = 'Full Year IO';
      } else {
        month = item.month.charAt(0).toUpperCase() + item.month.slice(1);
      }
      return this.columnActive.includes(month);
      // return item.month === 'total'
      //   ? 'Full Year IO'
      //   : item.month.charAt(0).toUpperCase() + item.month.slice(1);
    },
    dynamicSort(property) {
      var sortOrder = 1;

      if (property[0] === '-') {
        sortOrder = -1;
        property = property.substr(1);
      }

      return function(a, b) {
        if (sortOrder == -1) {
          return b[property].localeCompare(a[property]);
        } else {
          return a[property].localeCompare(b[property]);
        }
      };
    },
    nestedSort(prop, arr) {
      let desc = prop.includes('-') ? true : false;
      prop = prop.replace('-', '').split('.');
      var len = prop.length;
      if (desc) {
        arr.sort(function(a, b) {
          var i = 0;
          while (i < len) {
            a = a[prop[i]];
            b = b[prop[i]];
            i++;
          }
          if (a > b) {
            return -1;
          } else if (a < b) {
            return 1;
          } else {
            return 0;
          }
        });
        return arr;
      } else {
        arr.sort(function(a, b) {
          var i = 0;
          while (i < len) {
            a = a[prop[i]];
            b = b[prop[i]];
            i++;
          }
          if (a < b) {
            return -1;
          } else if (a > b) {
            return 1;
          } else {
            return 0;
          }
        });
        return arr;
      }
    },
    wdhFilter(val) {
      /*dynamic width advance filter modal*/
      let width = '';
      if (this.isLoggedInAsFinance) {
        switch (val) {
          case 'divisi':
            width = '30%';
            break;
          case 'house':
            width = '45%';
            break;
          case 'department':
            width = '60%';
            break;
          case 'budgetOwner':
            width = '75%';
            break;
        }
      }
      if (this.isLoggedInAsDirector) {
        switch (val) {
          case 'house':
            width = '30%';
            break;
          case 'department':
            width = '45%';
            break;
          case 'budgetOwner':
            width = '60%';
            break;
        }
      }
      if (this.isLoggedInAsBrandHead) {
        switch (val) {
          case 'department':
            width = '30%';
            break;
          case 'budgetOwner':
            width = '45%';
            break;
        }
      }
      if (this.isLoggedInAsDeptHead) {
        if (val === 'budgetOwner') {
          width = '40%';
        }
      }
      return width;
    },
    totalAmountFor_(key, itemData) {
      let amountFor = itemData.reduce((total, item) => {
        const value = +(item[key] || 0);
        total += value;
        return total;
      }, 0);
      if (Number(amountFor) === 0) {
        return '-';
      } else {
        return this.idr(Math.round(amountFor));
      }
    },
    bgStatus(val) {
      if (!val) {
        return '';
      } else {
        return 'softpink-bg';
      }
    },
    bgStatusActive(val, valActive) {
      if (valActive) {
        return 'active-io';
      } else {
        if (!val) {
          return '';
        } else {
          return 'softpink-bg';
        }
      }
    },
    bgReject(val, valActive) {
      if (valActive) {
        return 'active-io';
      } else {
        if (val == 'rejected') {
          return 'bgPink';
        } else {
          return '';
        }
      }
    },
    copy(aObject) {
      if (!aObject) {
        return aObject;
      }
      let v;
      let bObject = Array.isArray(aObject) ? [] : {};
      for (const k in aObject) {
        v = aObject[k];
        bObject[k] = typeof v === 'object' ? this.copy(v) : v;
      }
      return bObject;
    },
    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    }
  }
};
